import request from '../request';

export const getFxQuote = (data = {}) =>
  request.post('payments/fx-quote', data).then((res) => res);

export const cancelPaymentIntent = (data = {}) =>
  request.delete('payments/cancel-intent', { data }).then((res) => res);

export const getStripeConfig = () =>
  request.get('payments/stripe/config').then((res) => res);

export const createPaymentIntent = (data = {}) =>
  request.post('payments/stripe/payment-intent', data).then((res) => res);

export const replacePaymentIntent = (data = {}) =>
  request.post('payments/stripe/replace-intent', data).then((res) => res);

export const updatePaymentIntent = (paymentIntentId = '', data = {}) =>
  request
    .put(`payments/stripe/payment-intent/${paymentIntentId}`, data)
    .then((res) => res);
